import VerofreshRecord from './VerofreshRecord'

class RoutePlanFileUploadRecord extends VerofreshRecord {
  static endpoint = 'route-plan-file-upload'
  /**
   * Get human-readable status text
   */
  get statusText () {
    const statusLabels = {
      pending: 'Pending',
      processing: 'Processing',
      completed: 'Completed',
      failed: 'Failed',
      partially_failed: 'Partially Failed'
    }
    return statusLabels[this.status] || 'Unknown'
  }

  /**
   * Get upload method text
   */
  get uploadMethodText () {
    const methodLabels = {
      sftp: 'SFTP',
      gui: 'Web Interface',
      api: 'API'
    }
    return methodLabels[this.upload_method] || 'Unknown'
  }

  /**
   * Get formatted file size
   */
  get formattedFileSize () {
    if (!this.file_size) return '0 Bytes'
    const k = 1024
    const sizes = ['Bytes', 'KB', 'MB', 'GB']
    const i = Math.floor(Math.log(this.file_size) / Math.log(k))
    return parseFloat((this.file_size / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
  }

  /**
   * Get success rate percentage
   */
  get successRate () {
    const total = this.route_plans_created + this.route_plans_updated + this.route_plans_failed
    if (total === 0) return 0
    return Math.round(((this.route_plans_created + this.route_plans_updated) / total) * 100)
  }

  /**
   * Check if import can be reprocessed
   */
  get canReprocess () {
    return ['failed', 'partially_failed'].includes(this.status)
  }

  /**
   * Check if import has errors
   */
  get hasErrors () {
    return this.route_plans_failed > 0
  }
}

const relations = {
  hasMany: {
    RoutePlanFileUploadRoutePlan: {
      foreignKey: 'route_plan_file_upload_id',
      localField: 'route_plan_file_upload_route_plans'
    }
  },
  belongsTo: {
    User: {
      foreignKey: 'user_id',
      localField: 'user'
    }
  }
}

export default RoutePlanFileUploadRecord
export { relations }